import * as MyKeysApi from './index';
import { DatesRequest, MyKeysPromise, PageRequest } from './interfaces';
import { Activity, ActivityHistoryData, HistoryPageSize, Transfer, TransferBase } from '../../../modules/dialogs/transfer';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

export const requestValidateTransfer = (tx: Transfer): MyKeysPromise<number> => {
  const body = {
    deviceIds: tx.devices,
    transferId: tx.id
  };
  Logger.info(['POST: requestValidateTransfer', body], LogArea.Api);
  return MyKeysApi.post('Transfer/Request/Validate', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};

export const createRequestTransfer = (tx: Transfer): MyKeysPromise<boolean> => {
  const body = {
    transferId: tx.id
  };
  Logger.info(['POST: createRequestTransfer', body], LogArea.Api);
  return MyKeysApi.post('Transfer/Request/Create', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};

/***** Send *****/

export const sendValidateTransfer = (tx: Transfer): MyKeysPromise<number> => {
  const body = {
    deviceIds: tx.devices,
    transferId: tx.id,
    userCustomer: {
      customerId: tx.receiver.customer.customerId,
      userId: tx.receiver.userId
    }
  };
  Logger.info(['POST: validateSendTransfer', body], LogArea.Api);
  return MyKeysApi.post('Transfer/Send/Validate', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};

export const getUserCode = (tx: TransferBase): MyKeysPromise<boolean> => {
  const body = {
    transferId: tx.id
  };
  Logger.info(['POST: Get User Code', body], LogArea.Api);
  return MyKeysApi.post('Transfer/UserCode/Request', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};

export const checkUserCode = (tx: TransferBase, code: string): MyKeysPromise<boolean> => {
  const body = {
    transferId: tx.id,
    code
  };
  Logger.info(['POST: Check User Code', body], LogArea.Api);
  return MyKeysApi.post('Transfer/UserCode/Validate', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};

export const sendTransferDevices = (tx: Transfer): MyKeysPromise<boolean> => {
  const body = {
    transferId: tx.id
  };
  Logger.info(['POST: Send TransferDevices', body], LogArea.Api);
  return MyKeysApi.post('Transfer/Send/Transfer', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};

/***** Activities *****/

export const acceptTransferRequest = (tx: TransferBase): MyKeysPromise<boolean> => {
  const body = {
    transferId: tx.id
  };
  Logger.info(['POST: Accept Transfer Request', body], LogArea.Api);
  return MyKeysApi.post('Transfer/Request/Accept', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};

export const rejectTransferRequest = (tx: TransferBase): MyKeysPromise<boolean> => {
  const body = {
    transferId: tx.id
  };
  Logger.info(['POST: Reject Transfer Request', body], LogArea.Api);
  return MyKeysApi.post('Transfer/Request/Reject', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};

export const cancelTransferRequest = (tx: TransferBase): MyKeysPromise<boolean> => {
  const body = {
    transferId: tx.id
  };
  Logger.info(['POST: Cancel Transfer Request', body], LogArea.Api);
  return MyKeysApi.post('Transfer/Request/Cancel', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};

export const getClosedTransfers = (
  from?: string,
  to?: string
): MyKeysPromise<ActivityHistoryData> => {
  const pageReq: PageRequest = {
    pageIndex: 0,
    pageSize: HistoryPageSize,
  };
  const dateReq: DatesRequest = { from, to };
  const body = { ...pageReq, ...dateReq };
  return MyKeysApi.post('transfer/history/closed', body, true)
    .then((res) => MyKeysApi.Map.mapTransferHistoryDto(res.data))
    .catch(MyKeysApi.parseError);
};

export const getOpenTransfers = (
  from?: string,
  to?: string
): MyKeysPromise<ActivityHistoryData> => {
  const pageReq: PageRequest = {
    pageIndex: 0,
    pageSize: HistoryPageSize,
  };
  const dateReq: DatesRequest = { from, to };
  const body = { ...pageReq, ...dateReq };
  return MyKeysApi.post('transfer/history/open', body, true)
    .then((res) => MyKeysApi.Map.mapTransferHistoryDto(res.data))
    .catch(MyKeysApi.parseError);
};

export const getTxDetails = (transferId: number): MyKeysPromise<Activity> => {
  const body = { transferId };
  Logger.info(['POST: getTxDetails', body], LogArea.Api);
  return MyKeysApi.post('Transfer/GetDetails', body, true)
    .then((res) => MyKeysApi.Map.mapTransferDto(res.data))
    .catch(MyKeysApi.parseError);
};